import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const Header = () => {
  const [userName, setUserName] = useState("User");
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  const parseJwt = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch {
      return null;
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const decoded = parseJwt(token);

    const initialName =
      decoded?.fullName ||
      decoded?.displayName ||
      decoded?.name ||
      decoded?.username ||
      decoded?.email ||
      "User";

    setUserName(initialName);

    if (!decoded?.fullName && !decoded?.displayName) {
      fetch(`/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch profile");
          return res.json();
        })
        .then((data) => {
          if (data?.fullName) setUserName(data.fullName);
        })
        .catch(() => {});
    }
  }, []);

  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const initials = getInitials(userName);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <div className="relative flex items-center justify-between p-4 bg-white shadow">
      <h2 className="font-sans font-bold text-black">MTN Recruitment</h2>

      <div
        className="relative flex items-center gap-2 ml-auto cursor-pointer"
        onClick={() => setShowMenu((prev) => !prev)}
      >
        <span className="font-sans font-medium text-black">
          Welcome, {userName}!
        </span>
        <div className="w-8 h-8 font-medium font-sans rounded-full bg-[#FFCC00] flex items-center justify-center text-black">
          {initials}
        </div>

        {showMenu && (
          <div className="absolute right-0 z-10 w-32 mt-2 bg-white border border-gray-200 rounded shadow-lg top-12">
            <button
              onClick={handleLogout}
              className="w-full px-4 py-2 text-sm text-left text-black hover:bg-gray-100"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
